import React, { useEffect, useState } from "react";
import "./campaigncard.css";
import { ChevronLeft, Pencil, Plus, PlusIcon, Trash } from "lucide-react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Switch from "react-switch";
import DetailsCard from "./DetailsCard";
import TriggerCard from "./TriggerCard";
import MessageCard from "./MessageCard";
import apiServiceHandler from "../../service/apiService";
import "toastr/build/toastr.min.css";
import toastr from "toastr";
import { useDispatch, useSelector } from "react-redux";
import { updateRefreshCardData } from "../../redux/dripData";

const CampaignCards = () => {
  const navigate = useNavigate();
  const [checked, setChecked] = useState(false);
  const refreshCardData = useSelector((state) => state.dripData.refreshCardData)
  const dispatch = useDispatch()
  const [cardData, setCardData] = useState(null)
  const [loading, setLoading] = useState(true);


  const {id} = useParams()

  const toggleDripCampaign = async (status) => {
    setLoading(true)
    try {
      const response = await apiServiceHandler("PATCH", `api/drip-compaign/${id}`, {
        status: status ? 1 : 0,
      });
      if (response?.status) {
        toastr.success(response?.message);
        dispatch(updateRefreshCardData(true))
      }
    } catch (error) {
      console.log("Failed to toggle the campaign. Please try again!")
    }
    setLoading(false)
  }

  const handleChange = async (nextChecked) => {
    setChecked(nextChecked);
    await toggleDripCampaign(nextChecked);
  };

  const campaignData = async () => {
    try {
      const response = await apiServiceHandler('GET', `api/drip-compaign/${id}`, {} )
      setCardData(response?.campaign)
      setChecked(response?.campaign?.status === 1);
    } catch (error) {
      console.log("Failed to get the campaign data!") 
    }
  }

  useEffect(() => {
    campaignData()
  }, [id])

  useEffect(() => {
    if (refreshCardData) {
      campaignData()
    }

    dispatch(updateRefreshCardData(false))
  }, [refreshCardData])

  return (
    <div className="create-campaign-page">
      <div className="page-section-header">
        <div className="page-step-header">
          {/* eyebrow */}
          <div className="page-step-header-eyebrow">
            <div className="course-step-view-eyebrow">
              <button className="back-button" onClick={() => navigate(-1)}>
                <span className="icon">
                  <ChevronLeft size={32} />
                </span>
                <span className="button-label">Back</span>
              </button>
            </div>
          </div>

          <div className="page-header-subheading">
            <div className="page-subheader">
              <span>
                {" "}
                Define the flow and timing of your campaign by adding cards{" "}
              </span>
              <div className="switch">
                <div className="va-spacer">
                  {checked ? "Active" : "Deactivated"}
                </div>
                <Switch
                  checked={checked}
                  onChange={handleChange}
                  onColor="#86d3ff"
                  onHandleColor="#2693e6"
                  handleDiameter={30}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={20}
                  width={48}
                  className="react-switch"
                  id="material-switch"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-section-body">
        <section className="campaign-create-view__page">
          <div className="campaign-create-view__main">
            <div className="drip-gameboard">
              <div className="cards-wrapper">
                <DetailsCard cardData={cardData} />
                <TriggerCard cardData={cardData} />
                <MessageCard cardData={cardData} />
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default CampaignCards;
